import React from "react";
import "../../App.css";
import Footer from "../Footer";

export default function Products() {
  return (
    <>
      <Footer />
    </>
  );
}
